import { Link } from 'react-router-dom';
import { PawPrint, Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 text-white font-bold text-xl mb-4">
              <PawPrint className="w-8 h-8" />
              <span className="font-heading tracking-tight">SaferPaws</span>
            </Link>
            <p className="text-white/80 leading-relaxed max-w-md">
              Smart pet tags that help lost pets get home faster. 
              No app required. Just scan, contact, reunite.
            </p>
            <p className="mt-4 text-white/60 text-sm italic">
              &ldquo;Scan. Contact. Reunite.&rdquo;
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/shop" className="text-white/80 hover:text-white transition-colors">
                  Shop Tags
                </Link>
              </li>
              <li>
                <Link to="/activate" className="text-white/80 hover:text-white transition-colors">
                  Activate Tag
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-white/80 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/80 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/80">
                <Mail className="w-4 h-4" />
                <a href="mailto:hello@saferpaws.co.uk" className="hover:text-white transition-colors">
                  hello@saferpaws.co.uk
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <Phone className="w-4 h-4" />
                <span>Email Support</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} SaferPaws. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
